import { Navbar } from 'rsuite'
import CheveronLeft from 'shared/Icons/CheveronLeft';
import logoIcon from 'assets/icons/logo-white.png'
import clsx from 'clsx';

interface ComponentProps {
  expand: boolean;
  onChange(): void;
}

export default function NavToggle({ onChange }: ComponentProps) {
  return (
    <Navbar appearance="subtle" className={clsx("nav-toggle")}  >
      <div className="nav-toggle-wrapper">
        <div className="nav-logo-container" >
          <img src={logoIcon} alt='BattleXO'   />
        </div>
        <button className='nav-toggle-button' onClick={onChange}><CheveronLeft fontSize={20} /></button>
      </div>
    </Navbar>
  )
}
